export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-15-ea586a045776e036c265bcfc44adc321.jpg";